export default __webpack_public_path__ + "static/media/BackgroundCreateNewKahshMobile.7977045b.png";